var path = 'views/about.html';
var html = "<div class=\"about panel\" translate-sanitize-strategy=\"'sanitize'\" translate-values=\"{ rootUrl: '{{$root.faithlifeUrl}}' }\" translate-compile translate>about.aboutAmber</div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;